export interface FederationSignUpResult {
  response: FederationSignUpResponse;
  email: string;
}

export const enum FederationSignUpResponse {
  USER_FOUND = "UserAlreadyExists",
  USER_NOT_FOUND = "UserNotFoundError",
  USER_DISABLED = "UserDisabledError", // Error thrown by PreSignUp Lambda trigger
  USER_DISABLED_AFTER = "User is not enabled", // Error thrown by OAuth 2 flow when the user was disabled (after successfully link the Google IDP to native Cognito user)
  RESPONSE_NOT_PARSED = "",
}
